module.exports = __webpack_public_path__ + "67070d5e0698e559989e1e0d4abaf881.svg";